import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3919cfbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "housing-availability-search__body-title" }
const _hoisted_2 = { class: "housing-availability-search__body-title" }
const _hoisted_3 = {
  key: 0,
  class: "housing-card"
}
const _hoisted_4 = { class: "housing-card__header" }
const _hoisted_5 = { class: "housing-card__heading-wrapper" }
const _hoisted_6 = { class: "headline-4" }
const _hoisted_7 = { class: "body-2 housing-card__category-tag" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "housing-card__divider" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "housing-card__footer"
}
const _hoisted_10 = { class: "housing-card__price body-1-semi" }
const _hoisted_11 = { class: "housing-card__prices-wrapper" }
const _hoisted_12 = {
  key: 0,
  class: "housing-card__price housing-card__price--base housing-card__price--discounted"
}

import { computed, PropType, ref, watch } from 'vue'
import BaseNumberIncrementer from '@/components/BaseNumberIncrementer.vue'
import {
  CompanyHousingDateAvailability,
  Guests,
  HousingInformation,
  PeriodAvailability,
  PeriodAvailabilityPayload,
} from '@/models/public/service.model'
import { isHousingDateAvailable } from '@/utils/booking-widget'
import isValid from 'date-fns/isValid'
import { PublicService } from '@/models/public/bookingWidget.model'
import DatePicker from '@/components/DatePicker.vue'
import { ALERT_TYPES, FORMATS, SIZES } from '@/enums/components'
import { TRANSLATION_TYPE } from '@/enums/public'
import HousingUnitGuestsMapper from '@/components/public/housing/HousingUnitGuestsMapper.vue'
import BaseIcon from '@/components/BaseIcon.vue'
import BaseButton from '@/components/BaseButton.vue'
import { isNumeric } from '@/utils/general'
import { formatCurrency } from '@/utils/formatters'
import {
  useFetchCompanyPeriodAvailability,
  useFetchServiceHousingInformationBookingWidgetMutation,
} from '@/queries/public/services'
import { getValidationErrorData } from '@/utils/errors'
import { calculateHousingGuests } from '@/utils/services'
import { format, formatISO } from 'date-fns'
import { debounce } from 'lodash'
import { Alert } from '@/models/shared.model'
import { useI18n } from 'vue-i18n'
import differenceInDays from 'date-fns/differenceInDays'
import {
  CreateHousingServiceOrderItem,
  Order,
} from '@/models/public/order.model'
import {
  createHousingServiceOrderItem,
  useCreateOrderMutation,
} from '@/queries/cart'


export default /*#__PURE__*/_defineComponent({
  __name: 'HousingCard',
  props: {
  selectedService: {
    type: Object as PropType<PublicService>,
    required: true,
  },
  selectedStartDate: {
    type: Object as PropType<Date | null>,
    default: null,
  },
  selectedEndDate: {
    type: Object as PropType<Date | null>,
    default: null,
  },
  selectedAdultCount: {
    type: Number,
    default: 1,
  },
  selectedKidCount: {
    type: Number,
    default: 0,
  },
  housingAvailabilities: {
    type: Array as PropType<CompanyHousingDateAvailability[]>,
    default: () => [],
  },
  order: {
    type: Object as PropType<Order | null>,
    default: null,
  },
},
  emits: ["update:selectedStartDate", "update:selectedEndDate", "update:selectedAdultCount", "update:selectedKidCount", "update:order", "onErrorsChange"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:selectedStartDate', newDateString: Date): void
  (e: 'update:selectedEndDate', newDateString: Date): void
  (e: 'update:selectedAdultCount', newAdultCount: number): void
  (e: 'update:selectedKidCount', newKidCount: number): void
  (e: 'update:order', newOrder: Order): void
  (e: 'onErrorsChange', newErrors: Record<string, string>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const i18n = useI18n()
const errors = ref<Record<string, string>>({})
const housingInfo = ref<HousingInformation | undefined>(undefined)
const availability = ref<PeriodAvailability | undefined>(undefined)
const isShowAllUnitGuests = ref<boolean>(false)
const loading = ref<boolean>(false)
const cancelSelectedGuestsRecalculate = ref<boolean>(false)
const selectedHousingUnitGuests = ref<Guests[]>([])
const debouncedUpdates = debounce(fetchData, 400)

const isAvailable = computed<boolean>(
  () =>
    !!(
      availability.value &&
      !availability.value.is_min_advance_time_past &&
      availability.value.available_guests >=
        props.selectedAdultCount + props.selectedKidCount
    ),
)

const nights = computed(() =>
  props.selectedStartDate && props.selectedEndDate
    ? differenceInDays(props.selectedEndDate, props.selectedStartDate)
    : 1,
)

const isDiscounted = computed<boolean>(
  () => housingInfo.value?.base_total !== housingInfo.value?.discounted_total,
)

const housingUnitGuests = computed<Guests[]>(() => {
  const housingUnits =
    Array.from(Array(getMaxHousingUnits()).keys()).map(() => ({
      adults: 0,
      children: 0,
    })) || []
  return housingUnits.map((item, index) => ({
    adults: selectedHousingUnitGuests.value[index]?.adults || 0,
    children: selectedHousingUnitGuests.value[index]?.children || 0,
  }))
})

const alerts = computed<Alert[]>(() => {
  const alertList: Alert[] = []
  const nonFieldErrors = (errors.value?.non_field_errors || []) as Array<string>
  for (const errorMessage of nonFieldErrors) {
    alertList.push({
      text: errorMessage,
      alertType: ALERT_TYPES.DANGER,
    })
  }
  if (!availability.value) {
    alertList.push({
      text: i18n.t('searchToSeeResultsInfo', {
        maxGroupSize: housingInfo.value?.housing.max_guests,
      }),
      alertType: ALERT_TYPES.INFO,
    })
  }
  if (availability.value?.is_min_advance_time_past) {
    alertList.push({
      text: i18n.t('minAdvanceTimePastWarning'),
      alertType: ALERT_TYPES.WARNING,
    })
  }
  return alertList
})

const { mutateAsync: createOrder } = useCreateOrderMutation()

const { mutateAsync: fetchHousingInfo } =
  useFetchServiceHousingInformationBookingWidgetMutation()

const { mutateAsync: fetchPeriodAvailability } =
  useFetchCompanyPeriodAvailability()

watch(
  () => props.selectedService,
  () => {
    errors.value = {}
  },
)

watch(
  () => [
    props.selectedStartDate,
    props.selectedEndDate,
    props.housingAvailabilities,
  ],
  () => {
    if (props.selectedStartDate) {
      checkAvailabilityErrors(props.selectedStartDate, 'arrival')
      checkAvailabilityErrors(props.selectedStartDate, 'departure')
    }
    if (props.selectedEndDate) {
      checkAvailabilityErrors(props.selectedEndDate, 'arrival')
      checkAvailabilityErrors(props.selectedEndDate, 'departure')
    }
  },
)

watch(
  () => [
    props.selectedService,
    props.selectedStartDate,
    props.selectedEndDate,
    getAdultsCount(),
    getKidsCount(),
  ],
  debouncedUpdates,
)

watch(
  () => [
    props.selectedAdultCount,
    props.selectedKidCount,
    props.selectedService.housings_information?.max_guests,
  ],
  () => {
    if (!cancelSelectedGuestsRecalculate.value) {
      selectedHousingUnitGuests.value = calculateHousingGuests(
        props.selectedAdultCount,
        props.selectedKidCount,
        getMaxHousingUnits(),
        props.selectedService.housings_information?.max_guests,
      )
    }
    cancelSelectedGuestsRecalculate.value = false
  },
)

watch(
  () => getMaxHousingUnits(),
  () => {
    selectedHousingUnitGuests.value = calculateHousingGuests(
      props.selectedAdultCount,
      props.selectedKidCount,
      getMaxHousingUnits(),
      props.selectedService.housings_information?.max_guests,
    )
  },
)

async function fetchData() {
  await searchAvailability()
  await updateHousingInfo()
}

async function searchAvailability() {
  delete errors.value.non_field_errors
  if (
    !props.selectedService ||
    !props.selectedStartDate ||
    !props.selectedEndDate
  )
    return

  const payload: PeriodAvailabilityPayload = {
    company: props.selectedService.company,
    start: format(props.selectedStartDate, 'yyyy-MM-dd'),
    end: format(props.selectedEndDate, 'yyyy-MM-dd'),
    services: [props.selectedService.hash_id],
    group_size: getAdultsCount() + getKidsCount(),
  }

  try {
    const periodAvailability = await fetchPeriodAvailability(payload)
    const serviceAvailability = periodAvailability.length
      ? periodAvailability[0]
      : undefined
    availability.value = serviceAvailability
    return serviceAvailability
  } catch (error) {
    errors.value = { ...errors.value, ...getValidationErrorData(error) }
  }
}

const updateHousingInfo = async () => {
  if (
    !props.selectedService ||
    !props.selectedStartDate ||
    !props.selectedEndDate
  )
    return
  delete errors.value.guests
  try {
    const newHousingInfo = await fetchHousingInfo({
      serviceHash: props.selectedService.hash_id,
      check_in: format(props.selectedStartDate, 'yyyy-MM-dd'),
      check_out: format(props.selectedEndDate, 'yyyy-MM-dd'),
      guests: selectedHousingUnitGuests.value,
    })
    housingInfo.value = newHousingInfo
    return newHousingInfo
  } catch (error) {
    errors.value = { ...errors.value, ...getValidationErrorData(error) }
  }
}

const handleAddHousingToCart = async () => {
  if (!props.selectedStartDate || !props.selectedEndDate) return

  loading.value = true
  if (errors.value.order) {
    delete errors.value.order
  }
  let orderUuid = props.order?.uuid
  const payload: CreateHousingServiceOrderItem = {
    service: props.selectedService.id,
    check_in: formatISO(props.selectedStartDate, {
      representation: 'date',
    }),
    check_out: formatISO(props.selectedEndDate, {
      representation: 'date',
    }),
    guests: selectedHousingUnitGuests.value,
    additional_services: {},
    requests: '',
    referral_type: '',
    referral_code: '',
    item_group: null,
  }
  try {
    if (!orderUuid) {
      const order = await createOrder()
      if (order) {
        orderUuid = order.uuid
      }
    }
    if (orderUuid) {
      const updatedOrderData = await createHousingServiceOrderItem(
        orderUuid as string,
        payload,
      )
      emit('update:order', updatedOrderData.data)
    }
  } catch (error: unknown) {
    // @ts-ignore
    errors.value.order = getValidationErrorData(error)
  }
  loading.value = false
}

const handleBuy = async () => {
  if (props.order?.uuid) {
    window.open(window.location.origin + '/order/' + props.order.uuid)
  }
}

function updateStartDate(newDate: Date) {
  if (!isValid(newDate)) return

  const hasErrors = checkAvailabilityErrors(newDate, 'arrival')
  if (hasErrors) return

  emit('update:selectedStartDate', newDate)
}

function updateEndDate(newDate: Date) {
  if (!isValid(newDate)) return

  const hasErrors = checkAvailabilityErrors(newDate, 'departure')
  if (hasErrors) return

  emit('update:selectedEndDate', newDate)
}

const updateHousingUnitGuests = (item: Guests, index: number) => {
  if (!item.adults && !item.children) {
    selectedHousingUnitGuests.value.splice(index, 1)
  } else {
    selectedHousingUnitGuests.value[index] = item
  }

  emit(
    'update:selectedAdultCount',
    getAdultsCount(selectedHousingUnitGuests.value),
  )
  emit('update:selectedKidCount', getKidsCount(selectedHousingUnitGuests.value))
  cancelSelectedGuestsRecalculate.value = true
}

function getMaxHousingUnits(newAvailability?: PeriodAvailability) {
  return (
    (newAvailability || availability.value)?.available_quantity ??
    housingInfo.value?.housing.quantity ??
    0
  )
}

function getAdultsCount(newValue?: Guests[]) {
  return (newValue || selectedHousingUnitGuests.value).reduce(
    (acc: number, value: Guests) => acc + value.adults,
    0,
  )
}

function getKidsCount(newValue?: Guests[]) {
  return (newValue || selectedHousingUnitGuests.value).reduce(
    (acc: number, value: Guests) => acc + value.children,
    0,
  )
}

const isUnavailableDay = (day: Date) =>
  !isHousingDateAvailable(
    day,
    props.housingAvailabilities,
    props.selectedStartDate,
    props.selectedEndDate,
  )

const checkAvailabilityErrors = (newDate: Date, key: string) => {
  const available = isHousingDateAvailable(
    newDate,
    props.housingAvailabilities,
    props.selectedStartDate,
    props.selectedEndDate,
  )

  if (!available) {
    errors.value = {
      ...errors.value,
      [key]: i18n.t('bookingWidget.errors.availability'),
    }
    return true
  }
  delete errors.value[key]
  return false
}

return (_ctx: any,_cache: any) => {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t('whenAreYouGoing')), 1),
    _createVNode(DatePicker, {
      name: "arrival",
      "model-value": __props.selectedStartDate,
      label: _ctx.$t('arrival'),
      errors: [errors.value?.arrival],
      "disabled-dates": isUnavailableDay,
      type: "date",
      "onUpdate:modelValue": updateStartDate
    }, null, 8, ["model-value", "label", "errors"]),
    _createVNode(DatePicker, {
      name: "departure",
      "model-value": __props.selectedEndDate,
      label: _ctx.$t('departure'),
      errors: [errors.value?.departure],
      "disabled-dates": isUnavailableDay,
      type: "date",
      "onUpdate:modelValue": updateEndDate
    }, null, 8, ["model-value", "label", "errors"]),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('howManyAreYou')), 1),
    _createVNode(BaseNumberIncrementer, {
      label: _ctx.$t('adult'),
      "min-amount": 1,
      amount: __props.selectedAdultCount,
      onClickMinus: _cache[0] || (_cache[0] = 
      () => emit('update:selectedAdultCount', __props.selectedAdultCount - 1)
    ),
      onClickPlus: _cache[1] || (_cache[1] = 
      () => emit('update:selectedAdultCount', __props.selectedAdultCount + 1)
    )
    }, null, 8, ["label", "amount"]),
    _createVNode(BaseNumberIncrementer, {
      label: _ctx.$t('children'),
      amount: __props.selectedKidCount,
      onClickMinus: _cache[2] || (_cache[2] = () => emit('update:selectedKidCount', __props.selectedKidCount - 1)),
      onClickPlus: _cache[3] || (_cache[3] = () => emit('update:selectedKidCount', __props.selectedKidCount + 1))
    }, null, 8, ["label", "amount"]),
    (housingInfo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alerts), (alert, alertIndex) => {
              return (_openBlock(), _createBlock(_component_AlertBanner, _mergeProps({ key: alertIndex }, alert), null, 16))
            }), 128)),
            (availability.value && !_unref(isAvailable))
              ? (_openBlock(), _createBlock(_component_AlertBanner, {
                  key: 0,
                  text: _ctx.$t('noAvailabilityWarning'),
                  "alert-type": _unref(ALERT_TYPES).WARNING
                }, null, 8, ["text", "alert-type"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(__props.selectedService.name?.content || __props.selectedService.name) + " ", 1),
                (__props.selectedService?.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
                  ? (_openBlock(), _createBlock(BaseIcon, {
                      key: 0,
                      icon: "google-translate",
                      style: {"height":"16px","min-height":"16px","width":"revert","display":"block"}
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(housingInfo.value?.housing.category), 1)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(housingUnitGuests), (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: index + JSON.stringify(item)
            }, [
              _createVNode(HousingUnitGuestsMapper, {
                "housing-info": housingInfo.value,
                "model-value": item,
                errors: errors.value?.guests?.length && errors.value.guests[index],
                disabled: !availability.value || !_unref(isAvailable),
                class: "housing-card__unit-wrapper",
                "onUpdate:modelValue": (item) => updateHousingUnitGuests(item, index)
              }, null, 8, ["housing-info", "model-value", "errors", "disabled", "onUpdate:modelValue"]),
              _hoisted_8
            ])), [
              [_vShow, isShowAllUnitGuests.value || index < selectedHousingUnitGuests.value.length]
            ])
          }), 128)),
          (_unref(housingUnitGuests).length > selectedHousingUnitGuests.value.length)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 0,
                label: _ctx.$t('housingUnit.displayAll'),
                format: _unref(FORMATS).TERTIARY,
                size: _unref(SIZES).SMALL,
                icon: isShowAllUnitGuests.value ? 'chevron-up' : 'chevron-down',
                "icon-right": true,
                class: "housing-card__unit-guests-toggle",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (isShowAllUnitGuests.value = !isShowAllUnitGuests.value), ["prevent"]))
              }, null, 8, ["label", "format", "size", "icon"]))
            : _createCommentVNode("", true),
          (availability.value && _unref(isAvailable))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_unref(nights)) + " " + _toDisplayString(_unref(nights) < 2 ? _ctx.$t('night') : _ctx.$t('nights')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_unref(isDiscounted))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(isNumeric)(housingInfo.value?.base_total)
                ? _unref(formatCurrency)(housingInfo.value?.base_total)
                : '- €'), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["housing-card__price", [_unref(isDiscounted) && 'housing-card__price--discounted']])
                    }, _toDisplayString(_unref(isNumeric)(housingInfo.value?.discounted_total)
                ? _unref(formatCurrency)(housingInfo.value?.discounted_total)
                : '- €'), 3)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(BaseButton, {
      loading: loading.value,
      disabled: 
      Object.keys(errors.value).length ||
      !__props.selectedStartDate ||
      !__props.selectedEndDate ||
      !getAdultsCount()
    ,
      onOnClick: handleAddHousingToCart
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('bookingWidget.addToCart')), 1)
      ]),
      _: 1
    }, 8, ["loading", "disabled"]),
    _createVNode(BaseButton, {
      class: "housing-availability-search__button",
      disabled: !__props.order,
      loading: loading.value,
      onOnClick: handleBuy
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('bookingWidget.goToBuy')), 1)
      ]),
      _: 1
    }, 8, ["disabled", "loading"])
  ], 64))
}
}

})